export default "__VITE_ASSET__3ac6f24c__"